import { StylesConfig } from 'react-select'

type MyOptionType = {
  label: JSX.Element | string
  value: string
}

type IsMulti = boolean

export const customSelectStyles: StylesConfig<MyOptionType, IsMulti> = {
  control: (provided) => ({
    ...provided,
    borderRadius: '8px',
    border: '1px solid #d1d5db',
    boxShadow: 'none',
    height: '42px', //42 px to match the Increment components 40px height and 2px parent padding
    '&:hover': { borderColor: '#9ca3af' }, // Slightly darker on hover
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#4B5563',
    '& svg': {
      fill: '#4B5563',
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '8px', //  border radius on dropdown
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#4b5563' // Keep the selected option dark
      : state.isFocused
        ? '#e5e7eb' // Light gray for hovered but non-selected options
        : '#fff', // Default background for other options
    color: state.isSelected ? '#fff' : '#374151', // Ensure selected option remains readable
    '&:hover': {
      backgroundColor: state.isSelected ? '#4b5563' : '#e5e7eb', // Prevent excessive gray on selected hover
    },
  }),
}
